import React from "react";
import cx from "classnames";

import styles from "./radioOption.module.scss";
import { DropDown } from "../dropdown";

const THEMES: { key: string; label: string }[] = [
  { key: "light", label: "Light" },
  { key: "dark", label: "Dark" },
];

interface RadioOptionProps {
  selected: boolean;
  darkViewer: boolean;
  label: string;
  value: string;
  description?: string;
  onSelect: () => void;
  onThemeChange: (value: boolean) => void;
}

const RadioOption: React.FC<RadioOptionProps> = ({
  selected,
  darkViewer,
  label,
  value,
  description,
  onSelect,
  onThemeChange,
}) => {
  return (
    <div className={styles.optionWrapper}>
      <img
        src={
          value === "BINGE"
            ? "/images/experiences/bingeSelected.svg"
            : "/images/experiences/lightboxSelected.svg"
        }
        alt={label}
        className={styles.icon}
      />
      <div className={styles.contentWrapper}>
        <label className={styles.radioWrapper} onClick={onSelect}>
          <i
            className={cx(styles.checkbox, {
              "paperflite-radio-button-selected": selected,
              "paperflite-radio-button-unselected": !selected,
              [styles.primary]: selected,
            })}
            aria-hidden="true"
          />
          <span
            className={cx(styles.radioLabel, {
              [styles.primary]: selected,
            })}
          >
            {label}
          </span>
        </label>
        {description && <div className={styles.description}>{description}</div>}
      </div>
      {value === "LIGHTBOX" && selected && (
        <DropDown
          selected={darkViewer ? THEMES[1] : THEMES[0]}
          options={THEMES}
          onChange={(key) => onThemeChange(key === "dark")}
          align="end"
        />
      )}
    </div>
  );
};

export default RadioOption;
